<template>
  <div class="newpage">
    <div class="printTest-box">
      <div id="printTest">
        <div style="page-break-after:always" v-for="(item,index) in barCodeListCopy" :key="index">
          <div :style="sliderStyle">
            <div class="price">
              <div>Wholesale Price：MYR {{(item.price / 1.55).toFixed(2)}}</div>
              <div >Drop Shipping From Malysia </div>
              <div class="picBox">
                <img style="width:85%;" :src="item.codeUrl" />
              </div>
              
            </div>
            <div class="textDesc">
                  <div  class="grounName">name：{{item.groupName || ''}}</div>
                  <div style="text-align: center;">sku：{{item.skuName}}</div>
              </div>
            
            
            
            
           
          </div>
        </div>
      </div>
    </div>
    <div style="flex: 1;">
      <div style="height: 200px;">
        <el-button
          style="margin: 20px 0 0 30px;"
          type="primary"
          v-print="'#printTest'"
          @click="hasPrint()"
        >{{$t('other.a342')}}</el-button>
        <el-button style="margin: 20px 0 0 30px;" type="primary" @click="printPDF()">{{$t('other.a343')}}</el-button>
      </div>
      <div style="display: flex;font-size: 14px;width: 100%;align-items: center;margin-bottom:15px">
        <div style="font-size: 14px;padding-left: 10px;">{{$t('other.a346')}}</div>
        <el-select
          style="margin-left: 15px;"
          size="mini"
          v-model="value"
          :placeholder="$t('other.a50')"
          @change="chosePage()"
        >
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </div>
      <div style="display: flex;font-size: 14px;width: 100%;align-items: center;margin-bottom:15px">
        <div style="font-size: 14px;padding-left: 10px;">{{$t('other.a347')}}</div>
        <span style="margin:0 15px">{{widthValue}}</span>
        <label style="font-size:14px;padding-left:10px">{{$t('other.a349')}}</label>
      </div>
      <div style="display: flex;font-size: 14px;width: 100%;align-items: center;margin-bottom:15px">
        <div style="font-size: 14px;padding-left: 10px;">{{$t('other.a348')}}</div>
        <span style="margin:0 15px">{{heightValue}}</span>
        <label style="font-size:14px;padding-left:10px">{{$t('other.a349')}}</label>
      </div>
      <div
        v-show="isPurchase"
        style="display: flex;font-size: 14px;width: 100%;align-items: center;margin-bottom:15px"
      >
        <div style="font-size: 14px;padding-left: 10px;">{{$t('other.a344')}}</div>
        <el-input
          style="width:120px;padding-left:15px"
          @keyup.native="copyPurchase"
          size="mini"
          v-model="purchaseNum"
          :placeholder="$t('other.a319')"
        ></el-input>
        <label style="font-size:14px;padding-left:10px">{{$t('other.a345')}}</label>
      </div>
    </div>
  </div>
</template>
<script>
import utils from "../../utils/utils";
import htmlToPdf from "../../utils/htmlToPdf";
import html2canvas from "html2canvas";
import JsPDF from "jspdf";
import api from "../../api/moudles/sellerpurchase";
import api2 from "../../api/api";
import { mapState, mapMutations, mapActions } from "vuex";
import loading from "../../components/loading";
import pdf from "vue-pdf";
export default {
  data() {
    return {
      th_printdata: [],
      arr: [],
      barCodeList: [],
      barCodeListCopy: [],
      value: 3,
      sliderStyle: {
        width: "97mm",
        height: "97mm",
        "background-color": "#fff",
        "margin-top": "10px",
        position: "relative",
        display: "flex",
        "flex-direction": "column",
        "align-items": "center"
      },
      widthValue: "100",
      heightValue: "100",
      isPurchase: false,
      purchaseNum: 1,
      checked: false,
      options: [
        {
          value: "10",
          label: this.$t("other.a350")+"(100*100mm)"
        },
        {
          value: "50",
          label: this.$t("other.a350")+"(50*50mm)"
        },
        {
          value: "30",
          label: this.$t("other.a350")+"(30*30mm)"
        },
        
        {
          value: "3060",
          label: this.$t("other.a350")+"(15*15mm)"
        }
      ],
      value: "10",
      loadingList: [],
      loadedList: [],
      currentPage2: 1,
      pageSize: 10,
      chooseList: null,
      generateOrderId: [],
      userId: JSON.parse(localStorage.getItem("userInfo")).userId,
      userAttr: null
    };
  },
  components: {
    loading,
    pdf
  },
  computed: {
    ...mapState({
      picklist: state => state.order.picklist,
      seller: state => state.login.userInfo.userId,
      buttonMapList: state => state.print.buttonMapList,
      userId: state => state.login.userInfo.userId || ""
    }),

    listCopy() {
      if (this.checked) {
        let list = this.th_printdata;
        let list2 = list.slice(
          (this.currentPage2 - 1) * this.pageSize,
          this.currentPage2 * this.pageSize
        );
        console.log(list2);
        console.log(list);
        this.chooseList = list2;
        return list2;
      } else {
        return this.th_printdata;
      }
    }
  },
  watch: {
    listCopy() {
      console.log(this.listCopy);
    },
    userAttr() {
      console.log(this.userAttr);
    }
  },
  created() {
    // this.src=pdf.createLoadingTask(this.src)

    this.init();
  },

  methods: {
    ...mapActions("order", [
      "getUnprocessOrder", //获取所有商店待处理订单
      "auditOrder",
      "getPrintOrder", //打印订单
      "getOrdersBytrickNo"
    ]),
    ...mapActions("print", ["addPrintNum"]),
    ...mapMutations("print", [
      "SET_ITEMS",
      "SET_HAS_PRINTED",
      "SET_TTP",
      "SET_HAS_PRINTED_READY",
      "INIT_DATA",
      "FAST_PRINT",
      "UPDATA_PAGE",
      "SENT_PPT"
    ]),

    isDistribute(id) {
      let ttp = utils.isDistributionStroe(id);
      return utils.isDistributionStroe(id);
    },

    copyPurchase() {
      console.log(222);
      let arr = [];
      arr = Array(Number(this.purchaseNum)).fill(this.barCodeListCopy[0]);
      this.barCodeListCopy = arr;
      console.log("ar", arr);
    },

    hasPrint() {
      localStorage.setItem("reprintedOrder", true);
    },

    addPrintTime() {
      // htmlToPdf.downloadPDF(document.querySelector('#printTest'), this.$t("other.a352"))
      // let arr = []
      // this.listCopy.forEach(p => {
      // 	if(p.trackingNo !== "" && p.image!== null) {
      // 		arr.push(p.orderId)
      // 	}
      // })
      // this.addPrintNum(arr)
    },

    printPDF() {
      // let params={
      // 	orderId:this.$route.query.purchaseOrderId,

      // }

      utils.getUserAtt({ userId: this.userId }).then(res => {
        api2
          .printPdf({
            orderId: JSON.parse(JSON.parse(res.attribute).purchaseOrderId)
          })
          .then(res => {
            if (res.code === 200) {
              window.open(res.data);
            }
          });
      });
    },

    exportPDF() {
      // let shareContent = document.body,//需要截图的包裹的（原生的）DOM 对象
      let shareContent = document.getElementById("printTest"), //需要截图的包裹的（原生的）DOM 对象
        width = shareContent.clientWidth, //获取dom 宽度
        height = shareContent.clientHeight, //获取dom 高度
        canvas = document.createElement("canvas"), //创建一个canvas节点
        scale = 1; //定义任意放大倍数 支持小数
      canvas.width = width * scale; //定义canvas 宽度 * 缩放
      canvas.height = height * scale; //定义canvas高度 *缩放
      canvas.style.width = shareContent.clientWidth * scale + "px";
      canvas.style.height = shareContent.clientHeight * scale + "px";
      canvas.getContext("2d").scale(scale, scale); //获取context,设置scale
      let opts = {
        scale: scale, // 添加的scale 参数
        canvas: canvas, //自定义 canvas
        logging: false, //日志开关，便于查看html2canvas的内部执行流程
        width: width, //dom 原始宽度
        height: height,
        useCORS: true // 【重要】开启跨域配置
      };
      html2canvas(shareContent, opts)
        .then(() => {
          let contentWidth = canvas.width;
          let contentHeight = canvas.height;
          //一页pdf显示html页面生成的canvas高度;
          let pageHeight = (contentWidth / 592.28) * 841.89;
          //未生成pdf的html页面高度
          let leftHeight = contentHeight;
          //页面偏移
          let position = 0;
          //a4纸的尺寸[595.28,841.89]，html页面生成的canvas在pdf中图片的宽高
          let imgWidth = 595.28;
          let imgHeight = (592.28 / contentWidth) * contentHeight;
          let pageData = canvas.toDataURL("image/jpeg", 1.0);
          // let PDF = new JsPDF("", "pt", "a4");  // a4纸纵向
          // let PDF = new JsPDF('landscape');  // 横向页面
          let arrDPI = this.js_getDPI(); //获取显示器DPI
          let dpiX = 96;
          let dpiY = 96;
          if (arrDPI.length > 0) {
            dpiX = arrDPI[0];
            dpiY = arrDPI[1];
          }
          //l:横向， p：纵向；单位： in:英寸，mm毫米；画布大小：a3,a4,leter,[]（当内容为数组时，为自定义大小）
          let PDF = new JsPDF("l", "in", [
            (contentWidth + 10) / dpiX,
            (contentHeight + 10) / dpiY
          ]); // 自定义页面大小
          if (leftHeight <= pageHeight) {
            PDF.addImage(pageData, "JPEG", 5 / dpiX, 5 / dpiY);
          } else {
            while (leftHeight > 0) {
              PDF.addImage(pageData, "JPEG", 0, position);
              leftHeight -= pageHeight;
              position -= 841.89;
              if (leftHeight > 0) {
                PDF.addPage();
              }
            }
          }
          PDF.save(this.title + ".pdf"); // 这里是导出的文件名
        })
        .catch(() => {});
    },

    js_getDPI() {
      var arrDPI = new Array();
      if (window.screen.deviceXDPI != undefined) {
        arrDPI[0] = window.screen.deviceXDPI;
        arrDPI[1] = window.screen.deviceYDPI;
      } else {
        var tmpNode = document.createElement("DIV");
        tmpNode.style.cssText =
          "width:1in;height:1in;position:absolute;left:0px;top:0px;z-index:99;visibility:hidden";
        document.body.appendChild(tmpNode);
        arrDPI[0] = parseInt(tmpNode.offsetWidth);
        arrDPI[1] = parseInt(tmpNode.offsetHeight);
        tmpNode.parentNode.removeChild(tmpNode);
      }
      return arrDPI;
    },

    start_print() {
      this.$print(this.$refs.dfbfjj); //$refs的值要和html里的ref一致
    },

    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.pageSize = parseInt(`${val}`);
    },
    handleCurrentChange(val) {
      this.currentPage2 = parseInt(`${val}`);
      console.log(this.chooseList);
      this.getPirntPdf();
    },
    //开启分批打印时，触发面单再次请求
    getPirntPdf() {
      setTimeout(() => {
        console.log(this.chooseList);
        let arr = this.chooseList.map(p => {
          return p.logisticInfo && p.trackingNo === ""
            ? JSON.parse(p.logisticInfo.info_needed.methods)
            : null;
        });
        arr = utils.unique(arr);
        arr[0] === null ? arr.splice(0, 1) : arr[0];

        this.generateOrderId = arr.map(p => {
          if (p !== null) {
            return p.orderId;
          }
        });

        console.log(arr);
        console.log(this.generateOrderId);
        if (this.generateOrderId.length) {
          console.log(8888);
          api.startReadyOrders(arr).then(res => {
            if (res.code === 200) {
              console.log("发送订单请求", res.data);
              this.getNewOrderList(this.generateOrderId);
            }
          });
        }
      }, 1000);
    },

    //获取最新的面单
    getNewOrderList(arr) {
      api.getNewOrders(arr).then(res => {
        if (res.code === 200) {
          console.log("获取到最新的订单", res.data);
          let newData = res.data;
          newData.forEach(p => {
            this.th_printdata.forEach(i => {
              if (
                i.orderId == p.orderId &&
                p.image !== null &&
                p.ready == true
              ) {
                i.image = p.image;
              }
            });
            this.generateOrderId.forEach((k, index) => {
              if (k === p.orderId && p.ready == true && p.image !== null) {
                this.generateOrderId.splice(index, 1);
              }
            });
          });

          if (this.generateOrderId.length > 0) {
            this.getNewOrderList(this.generateOrderId);
          }
        }
      });
    },

    chosePage() {
      console.log(this.value);
      if (this.value == "10") {
        this.sliderStyle.width = "100mm";
        this.sliderStyle.height = "100mm";
        this.widthValue = "100";
        this.heightValue = "100";
      } else if (this.value === "50") {
        this.sliderStyle.width = "50mm";
        this.sliderStyle.height = "50mm";
        this.widthValue = "50";
        this.heightValue = "50";
      } else if (this.value === "30") {
        this.sliderStyle.width = "30mm";
        this.sliderStyle.height = "30mm";
        this.widthValue = "30";
        this.heightValue = "30";
      } else if (this.value == "3060") {
        this.sliderStyle.width = "15mm";
        this.sliderStyle.height = "15mm";
        this.widthValue = "15";
        this.heightValue = "15";
      }
    },

    oop1() {
      this.sliderStyle.height = this.heightValue + "mm";
    },
    oop() {
      console.log(this.widthValue);
      this.sliderStyle.width = this.widthValue + "mm";
    },
    //深拷贝数组
    copy(obj) {
      var newobj = [];
      if (typeof obj !== "object") {
        return;
      }
      for (var i in obj) {
        newobj[i] = typeof obj[i] === "object" ? this.copy(obj[i]) : obj[i];
      }
      return newobj;
    },

    //从storage上拿下将要打印的item
    init() {
      utils
        .getInfoByCache({
          cacheKey: "scanBarCode",
          userId: this.userId
        })
        .then(res => {
          this.barCodeListCopy = res;
          console.log(res);
        });
    },

    ttp() {
      var headstr = "<html><head><title></title></head><body>";
      var footstr = "</body>";
      var newstr = this.$refs.menuItem.innerHTML;
      const oldstr = document.body.innerHTML;
      document.body.innerHTML = headstr + newstr + footstr;
      setTimeout(() => {
        document.body.innerHTML = oldstr;
      }, 1000);
      window.print();
      return false;
    },

    getTiem(time) {
      console.log(time);
      if (typeof time == Array) {
        return "pending update";
      } else {
        return utils.renderTime(time);
      }
    }
  }
};
</script>

<style>
.newpage {
  width: 100%;
  background: #fff;
  z-index: 99999;
  display: flex;
  position: absolute;
  /* display: flex;
		flex-direction: column;
		justify-content: center; */
}

@page {
  margin: 0mm 0mm 0mm 0mm;
}
@page:first {
  margin-top: -5mm;
}

.barCode {
  border: 3px #000 solid;
  box-sizing: border-box;
  padding: 10px 0;
  margin: 5px;
  width: 90%;
  height: 90%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}

.grounName{
  max-width: 50%;
  overflow: hidden;
  text-align: center;
  text-overflow:ellipsis;
  white-space: nowrap;
}

.price{
  position: absolute;
  top: 5px;
  left: 0;
  right: 0;
  text-align: center;
  z-index: 9;
}

.textDesc{
  position: absolute;
  bottom: 10px;
  left: 0;
  right: 0;
  z-index: 9;
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-wrap: nowrap;
}

.picBox{
  position: absolute;
  top: 20px;
  left: 0;
  right: 0;
  text-align: center;
  z-index: -1;
}

.barCodecopy {
  box-sizing: border-box;
  padding: 10px 0;
  margin: 5px;
  width: 90%;
  height: 90%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}

.pic-box {
  width: 100%;
  image-rendering: -moz-crisp-edges;
  image-rendering: -o-crisp-edges;
  image-rendering: -webkit-optimize-contrast;
  image-rendering: crisp-edges;
  -ms-interpolation-mode: nearest-neighbor;
}

.newpage .pick-list-wrpper {
  width: 100%;

  font-size: 12px;
  position: relative;
}



.orderpage-btn {
  width: 800px;
  margin: 0 auto;
  display: flex;
  justify-content: flex-end;
  padding: 10px 0;
}

.newpage .print-area {
  margin-bottom: 200px;
}
.desc-info {
  width: 798px;

  border: 2px #000000 solid;
}

.newpage .orderpage-poo-box {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-bottom: 5px;
  border-bottom: 2px #000000 dashed;
}

.newpage .orderpage-poo {
  min-width: 265px;
  height: 40px;
  border: 2px solid #000000;
  text-align: center;
  line-height: 40px;
  font-size: 18px;
  font-weight: bold;
  margin: 5px 10px;
}

.newpage .receipt-item {
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
  padding: 5px 10px;
}

.newpage .receipt-item .area {
  display: inline-block;
  width: 50%;
  font-size: 18px;
}

.newpage .desc-info-left-text {
  font-size: 18px;
  font-weight: bold;
  padding-right: 30px;
}

.newpage .desc-info-footer {
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
  padding: 5px 10px;
}

.newpage .tto {
  display: inline-block;
  width: 200px;
  text-align: center;
  box-sizing: border-box;
  padding: 5px;
}
.newpage .tto01 {
  display: inline-block;
  width: 100px;
}
.newpage .cco {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  border-bottom: 1px #000000 solid;
  box-sizing: border-box;
  padding: 0 10px;
}

.newpage .prensku_box {
  height: 15px;
  width: 40mm;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.newpage .city-tap {
  display: inline-block;
  padding: 5px;
  border: 2px solid #000000;
  margin: 5px 0;
  padding: 5px 15px;
  font-size: 18px;
}

.newpage .city-tap01 {
  display: inline-block;
  padding: 5px;
  border: 2px solid #000000;
  margin: 5px 5px;
  font-size: 18px;
  padding: 5px 15px;
}

.newpage .newPage_desc {
  font-size: 20px;
  padding: 3px 10px;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
}

.newpage .newPage_desc_50 {
  font-size: 15px;
  font-weight: bold;
  padding: 1px 10px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.newpage .desc {
  /* position: absolute;
		top: 40%;
		left: 25%;
		bottom: 0;
		right: 0;
		margin: auto; */
  font-size: 18px;
  font-weight: bold;
  color: red;
  opacity: 0.3;
}
.newpage .oook {
  margin-bottom: 20px;
}

.loading-box {
  width: 100px;
  height: 100px;
  position: absolute;
  bottom: 0;
  top: 0;
  left: 0;
  right: 0;
  margin: auto;
  text-align: center;
}

/* 	.pp-wrapper{
		position: absolute;
		left: 0;
		right: 0;
		margin: 0 auto;
	}	 */

.newpage .printTest-box {
  width: 80%;
  overflow-y: auto;
  height: 100vh;
  background-color: #000;
  position: relative;
}

.newpage .page-box {
  /* width: 800px;
		height: 670px; */
  overflow: hidden;
  background-color: #fff;
  /* position: absolute;
		left: 0;
		right: 0;
		margin: 0 auto; */
}

.newpage .el-icon-loading:before {
  content: "\E6CF";
  font-size: 60px;
}

.el-popper {
  z-index: 999999 !important;
}

.img-wrapper {
  width: 1100px;
  height: 1188px;
  margin: -369.5px -354.5px;
  transform: scale(0.36);
}

.fenpi {
  display: flex;
  align-items: center;
  width: 100%;
  height: 50px;
  line-height: 50px;
  background-color: #fff;
  position: fixed;
  bottom: 0;
  z-index: 999999;
  font-size: 14px;
  padding-left: 15px;
}

.test_wrapper {
  width: 7000mm;
  height: 3000mm;
}

.fenpi-item {
  margin-right: 10px;
}
</style>
